module.exports = __webpack_public_path__ + "a6c8d78727bb3a7bf63ff39086ef18c6.mp4";


//////////////////
// WEBPACK FOOTER
// ./app/assets/video/tray_fr.mp4
// module id = 942
// module chunks = 4